import { Navigate, Route, HashRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import { SocketProvider } from './context/SocketContext';
import Account from './screens/Account';
import AdminDashboard from './screens/AdminDashboard';
import AdminVisits from './screens/AdminVisits';
import Analytics from './screens/Analytics';
import AreaHeadDashboard from './screens/AreaHeadDashboard';
import EngineerDashboard from './screens/EngineerDashboard';
import EngineerVisits from './screens/EngineerVisits';
import History from './screens/History';
import Login from './screens/Login';
import NewTicket from './screens/NewTicket';
import Notifications from './screens/Notifications';
import Profile from './screens/Profile';
import TicketDetails from './screens/TicketDetails';
import TicketsList from './screens/TicketsList';
import UserDashboard from './screens/UserDashboard';
import UserDetails from './screens/UserDetails';
import Users from './screens/Users';

function App() {
  return (
    <AuthProvider>
      <SocketProvider>
        <NotificationProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute requiredRoles={['admin']}>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="tickets" element={<TicketsList userRole="admin" />} />
            <Route path="tickets/:ticketId" element={<TicketDetails />} />
            <Route path="users" element={<Users />} />
            <Route path="users/:userId" element={<UserDetails />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="profile" element={<Profile />} />
            <Route path="visits" element={<AdminVisits />} />
          </Route>
          <Route
            path="/engineer/*"
            element={
              <ProtectedRoute requiredRoles={['engineer']}>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<EngineerDashboard />} />
            <Route path="tickets" element={<TicketsList userRole="engineer" />} />
            <Route path="tickets/:ticketId" element={<TicketDetails />} />
            <Route path="profile" element={<Profile />} />
            <Route path="visits" element={<EngineerVisits />} />
          </Route>
          <Route
            path="/user/*"
            element={
              <ProtectedRoute requiredRoles={['user', 'customer']}>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<UserDashboard />} />
            <Route path="history" element={<History />} />
            <Route path="new-ticket" element={<NewTicket />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="account" element={<Account />} />
            <Route path="tickets" element={<TicketsList userRole="customer" />} />
            <Route path="tickets/:ticketId" element={<TicketDetails />} />
          </Route>
          <Route
            path="/area-head/*"
            element={
              <ProtectedRoute requiredRoles={['area_head']}>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<AreaHeadDashboard />} />
            <Route path="tickets" element={<TicketsList userRole="area_head" />} />
            <Route path="tickets/:ticketId" element={<TicketDetails />} />
            <Route path="visits" element={<AdminVisits />} />
            <Route path="profile" element={<Profile />} />
          </Route>
          <Route path="/customer/*" element={<Navigate to="/user/dashboard" replace />} />
          <Route path="/" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
        </NotificationProvider>
      </SocketProvider>
    </AuthProvider>
  );
}

export default App;
